import React from "react";

class IconActionDownload extends React.Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={this.props.width}
                height={this.props.height}
                fill="none"
                viewBox="0 0 20 20"
            >
                <path
                    fill="#1D1D1D"
                    d="M20 14.042c0-.126 0-.27-.038-.395a1.12 1.12 0 00-1.193-.799c-.549.067-.962.53-.972 1.078-.01.655-.01 1.3 0 1.954v.857c0 .731-.327 1.059-1.058 1.059H3.252c-.712 0-1.049-.328-1.049-1.04v-.77c0-.645 0-1.309-.01-1.964-.01-.25-.086-.52-.22-.731-.26-.395-.76-.54-1.232-.385A1.1 1.1 0 000 13.936c0 1.02 0 2.04.01 3.06 0 .222.028.453.086.665.356 1.415 1.549 2.33 3.03 2.339h13.69c.183 0 .394 0 .596-.038 1.568-.299 2.579-1.521 2.588-3.11v-2.81z"
                ></path>
                <path
                    fill="#1D1D1D"
                    d="M9.187 15.726c.24.24.52.356.808.356.28 0 .568-.115.808-.346.125-.116.25-.24.366-.366l.452-.462 2.078-2.108c.327-.337.414-.75.23-1.194-.163-.413-.51-.664-.98-.683-.308-.02-.607.106-.857.356-.269.27-.538.53-.817.8l-.183.172V1.788c0-.24 0-.49-.01-.731-.01-.434-.23-.76-.625-.944A1.074 1.074 0 009.312.23C8.937.518 8.89.94 8.9 1.239V12.28l-.318-.317c-.24-.25-.481-.491-.731-.732a1.1 1.1 0 00-1.568.02 1.093 1.093 0 00.01 1.54c.961.981 1.933 1.963 2.895 2.935z"
                ></path>
            </svg>
        );
    }
}

IconActionDownload.defaultProps = {
    width: 20,
    height: 20
}

export default IconActionDownload;
